import React from "react"
import { useOutlet } from "react-router-dom"

export const Discounts = () => {
  const outlet = useOutlet()
  return <>{outlet}</>
}
